module.exports = "/assets/696c2dabab091d56c79628a125fab0cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/CX.png
// module id = 1281
// module chunks = 0